export default __webpack_public_path__ + "static/media/lauren.cec856eb.gif";